import { render } from "./waveform.vue?vue&type=template&id=c4c1111e&scoped=true"
import script from "./waveform.vue?vue&type=script&lang=js"
export * from "./waveform.vue?vue&type=script&lang=js"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c1111e"]])

export default __exports__